import { EnrollmentErrorCode } from '../../../../constants/enrollmentList/enrollmentList.constant';

export const getEnrollmentEditToolErrorMessage = (errorCode: EnrollmentErrorCode, errMessage: string): string => {
    let errorMessage = '';
    switch (errorCode) {
        case EnrollmentErrorCode.SUCCESS:
            errorMessage = 'Your change has been successfully updated.';
            break;
        case EnrollmentErrorCode.REQUEST_NULL:
            errorMessage = 'Request is null or empty. Please contact your Technical Support Team.';
            break;
        case EnrollmentErrorCode.ACTION_NULL:
            errorMessage = 'Action is null or empty. Please contact your Technical Support Team.';
            break;
        case EnrollmentErrorCode.ENROLLMENT_ID_NULL:
            errorMessage = 'Enrollment ID is null or empty. Please contact your Technical Support Team.';
            break;
        case EnrollmentErrorCode.NO_ENROLLMENT_FOUND:
            errorMessage = 'No enrollment found for given ID. Please contact your Technical Support Team.';
            break;
        case EnrollmentErrorCode.NO_MEMBER_FOUND:
            errorMessage =
                'No member found for given Exchange Individual Identifier. Please contact your Technical Support Team.';
            break;
        case EnrollmentErrorCode.CHANGE_OUTSIDE_DATES:
            errorMessage =
                'A change has been made to this enrollment outside of the requested dates. If you would like to override the changes, please contact your Technical Support Team. (Effective dates exist outside coverage)';
            break;
        case EnrollmentErrorCode.MEMBER_DATES_OUTSIDE:
            errorMessage =
                'A member’s enrollment dates fall outside of the dates entered. Please verify dates and enrollments for each member.';
            break;
        case EnrollmentErrorCode.MEMBER_LEVEL_DATES:
            errorMessage =
                'Member level dates are not within the dates of the overall enrollment. Please update the household enrollment before adjusting the individual member.';
            break;
        case EnrollmentErrorCode.START_DATE_BEFORE_BIRTH:
            errorMessage =
                "The date entered will cause member's Start date to be before their birth date. Please review the dates and try again.";
            break;
        case EnrollmentErrorCode.END_DATE_BEYOND_DEATH:
            errorMessage =
                "The date entered will cause member's End Date to be beyond the date of death. Please review the dates and try again.";
            break;
        case EnrollmentErrorCode.END_DATE_BEFORE_START:
            errorMessage =
                'The date entered will cause the Enrollment End Date to be before the Start Date. Please review and correct the dates.';
            break;
        case EnrollmentErrorCode.DATE_FIELD_BLANK:
            errorMessage = 'Date filed is blank. Please enter a valid date.';
            break;
        case EnrollmentErrorCode.ENROLLMENT_CANCELLED:
            errorMessage =
                'The enrollment you are trying to edit is Cancelled and cannot be edited. Please contact Technical Support.';
            break;
        case EnrollmentErrorCode.DATES_NOT_WITHIN_COVERAGE_YEAR:
            errorMessage = 'The date(s) entered are not within the correct Coverage Year.';
            break;
        case EnrollmentErrorCode.OVERLAPPING_ENROLLMENT:
            errorMessage =
                'Failure to apply changes due to another overlapping enrollment. Please contact Technical Support.';
            break;
        case EnrollmentErrorCode.MEMBER_BENEFIT_END_BEFORE_START:
            errorMessage = 'The provided Member Benefit End Date is smaller than Member Benefit Start Date.';
            break;
        case EnrollmentErrorCode.SUBSCRIBER_DATES_MISMATCH:
            errorMessage =
                "The Subscriber's Coverage Start/End dates do not match the Enrollment's Start/End dates. Please review the dates and try again.";
            break;
        case EnrollmentErrorCode.TECHNICAL_ERROR:
            errorMessage =
                'Technical Error Occurred. To edit this Enrollment, please reinstate through the application.';
            break;
        case EnrollmentErrorCode.COVERAGE_YEAR_MISMATCH:
            errorMessage = 'Coverage year mismatch, Please verify enrollment and member date';
            break;
        case EnrollmentErrorCode.CUSTOM_ERROR:
            errorMessage = errMessage;
            break;
        case EnrollmentErrorCode.FAILURE_TO_APPLY_CHANGES:
            errorMessage = 'Failure to apply changes. Please contact Technical Support.';
            break;
        case EnrollmentErrorCode.ENROLLMENT_START_DATE_MISMATCH:
            errorMessage =
                "The provided Enrollment Start Date and Subscriber's Benefit Start Dates do not match. Please review the dates and try again.";
            break;
        case EnrollmentErrorCode.ENROLLMENT_END_DATE_MISMATCH:
            errorMessage =
                "The provided Enrollment End Date and Subscriber's Benefit End Dates do not match. Please review the dates and try again.";
            break;
        case EnrollmentErrorCode.ENROLLMENT_COVERAGE_DATES_MISMATCH:
            errorMessage =
                "The provided Enrollment Coverage dates do not match with Subscriber's Benefit dates. Please review the dates and try again.";
            break;
        case EnrollmentErrorCode.ENROLLMENT_END_DATE_LESS_THAN_START:
            errorMessage = 'The provided Enrollment End Date is Less than Enrollment Start Date.';
            break;
        case EnrollmentErrorCode.ENROLLMENT_CANNOT_BE_REINSTATED:
            errorMessage =
                'This enrollment cannot be reinstated because a subsequent application has been submitted. If you need to reinstate this enrollment, please cancel any enrollments that have been created under the new application and cancel the new application first before attempting to reinstate this enrollment.';
            break;
        default:
            errorMessage = 'We apologize for the technical issue. Please try again after 10 minutes.';
    }

    return errorMessage;
};
